var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlecha(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 60,
    viewBox: "0 0 15 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65715 58.7846C7.04768 59.1752 7.68084 59.1752 8.07136 58.7846L14.4353 52.4207C14.8259 52.0302 14.8259 51.397 14.4353 51.0065C14.0448 50.6159 13.4116 50.6159 13.0211 51.0065L7.36426 56.6633L1.7074 51.0065C1.31688 50.6159 0.683714 50.6159 0.29319 51.0065C-0.0973344 51.397 -0.0973344 52.0302 0.29319 52.4207L6.65715 58.7846ZM7.36426 0L6.36426 0L6.36426 58.0775H7.36426H8.36426L8.36426 0L7.36426 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecha);
export default __webpack_public_path__ + "static/media/flecha.48ae96e0a52d43d86950a4ca4f4a9923.svg";
export { ForwardRef as ReactComponent };